import React, { ChangeEvent, useCallback } from 'react';
import Input, { InputProps } from '@material-ui/core/Input';
import { getIn, useFormikContext } from 'formik';
import { UdsFC } from '../../../types';
import { useAppFormControlContext } from './appFormControlContext';
import { appFormDataTestFactory } from './appFormDataTestFactory';

interface AppFormInputProps extends Omit<InputProps, 'onChange'> {
  onChange?: (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void | Promise<void>;
}

export const AppFormInput: UdsFC<AppFormInputProps> = ({ dataTest, ...rest }) => {
  const context = useAppFormControlContext();
  const { values, setFieldValue, setFieldTouched } = useFormikContext();

  const name = 'name' in rest ? rest.name : context.name;
  const value = 'value' in rest ? rest.value : name ? getIn(values, name) : undefined;
  const onChange = rest.onChange;
  const handleOnChange = useCallback(
    async (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      if (onChange) {
        await onChange(e);
      } else if (name) {
        await setFieldValue(name, e.target.value);
      }
      if (name) {
        await setFieldTouched(name);
      }
    },
    [name, onChange, setFieldTouched, setFieldValue]
  );
  return (
    <Input
      {...rest}
      required={false}
      value={value ?? ''}
      onChange={handleOnChange}
      id={(rest.id ?? context.name) ? `${context.name}-input` : undefined}
      disableUnderline
      data-test={appFormDataTestFactory(dataTest ?? context.dataTest).input}
      autoComplete="off"
      aria-autocomplete="none"
    />
  );
};
